<template>
	<div class="header">
		<div class="header_box container">
			
			<div class="flex-Hori header_Row">
				<div class="flex-Vert logoBox" @click="userClick('index')">
					<img src="https://sxh-1253575465.file.myqcloud.com/Integer_shop/img/1690512987YZQo.png"  style="height: 66px;" />
				</div>
				<div class="flex-Vert">
					
					<div class="flex-Hori" style="align-items: flex-start;">
						<div class="flex-Vert" style="height: 64px; margin-right: 80px;">
							<div class="searchBox">
								<input
									v-model.trim="searchKey" @keyup.enter="search"
									:placeholder="$t('common.goods-name')"
									:style="{
										opacity: (searchKey || '').length ? 1 : .618
									}"
								/>
								<div class="el-icon-search btn" @click="search"></div>
							</div>
							<div class="flex-Hori recommendList">
								搜索热词：
								<div
									v-for="(item, index) of recommendArr" :key="index"
									class="item" @click="searchKey = item, search()"
								>
									{{item}}
								</div>
							</div>
						</div>
					
						<el-popover width="300" ref="popover" trigger="click">
							<h4 style="padding-bottom: 10px;">{{$t('header.new-add')}}</h4>
							<div class="carBox" v-loading="loading">
								<el-scrollbar
									v-if="carData.length > 0"
									ref="scrollbar"
								>
									<div v-for="(shopItem,shopIndex) in carData" :key="shopIndex" style="margin-bottom: 10px;">
										<h5 style="margin-bottom: 5px;">{{shopItem.warehouse_name}}</h5>
										<div class="car_item" v-for="(item,index) in shopItem.list" :key="index">
											<div class="car_item_left">
												<img class="goods_img" :src="item.img" @click="goProduct(item.item_id)">
												<p>{{item.name}}</p>
											</div>
											<div
												class="car_item_right"
											>
											<!-- TODO: 购物车要显示规格，style要修改 -->
												<div class="info">
													<p
														class="spec"
														:title="item.std_name"
													>
														{{item.std_name}}
													</p>
													<p class="price">
														<span class="num">￥{{item.price}}</span> × {{item.num}}
													</p>
												</div>
												<p
													class="btn"
												>
													<span @click="delCar(item.cart_id)">{{$t('common.delete')}}</span>
												</p>
											</div>
										</div>
									</div>
								</el-scrollbar>
								<div v-else class="noData">
									<img src="https://sxh-1253575465.file.myqcloud.com/shops/image/icon/empty_car.png" />
									<span>{{$t('car.empty')}}</span>
								</div>
							</div>
							<div class="foot" v-if="carData.length>0">
								<span>{{userInfo.carNum}}{{$t('car.p1')}}</span>
								<div class="btn-General-01 btn-General-01--Danger" @click="goCar">{{$t('common.go-car')}}</div>
							</div>
							<template #reference>
								<!-- <el-button icon="el-icon-goods">{{userInfo.carNum}}{{$t('car.p1')}}</el-button> -->
								<div class="flex-Hori cart noSelect">
									<p class="txt">购物车</p>
									<i class="icon el-icon-shopping-cart-2"></i>
									<div class="cartItemNum">{{userInfo.carNum}}</div>
								</div>
							</template>
						</el-popover>
					</div>
					
				</div>
			</div>
			
		</div>
		<el-drawer
		  size="50%"
		  :visible.sync="drawer"
		  :with-header="false">
		  <el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" @select="menuSelect" menu-trigger="click" router>
		  	<el-menu-item 
		  		:index="index==0?'Index':'classify'+item.term_id" 
		  		:route="{path: index==0?'index':'classify',query:index==0?'':{id: item.term_id} }"
		  		v-for="(item,index) in navData" :key="index">{{item.name}}</el-menu-item>
		  </el-menu>
		</el-drawer>
		<el-page-header
			v-if="pageHead.isShow && false"
			class="pageHead container"
			:title="pageHead.title"
			:content="pageHead.content"
			@back="pageHead.callback"
		>
		</el-page-header>
	</div>
</template>

<script>
	import bus, { Evt_Header } from '../../assets/bus';
	import { mapGetters } from 'vuex'
	export default {
		props:{
			navData:{
				type:Array,
				default:[]
			},
			activeIndex:{
				type:String,
				default:""
			}
		},
		data() {
			return {
				evt_Arr: [{ evt: '', hdl: () => {} }],
				
				searchKey:"",
				loading:false,
				drawer:false,
				
				recommendArr: ['新品', '旅行装', '秒杀', '面膜', '防晒', '口红', '香水']
			}
		},
		computed: {
			...mapGetters([
				'userInfo',
				'carData',
				'pageHead'
			])
		},
		created() {
			this.getCarData()
			// 更新购物车数据
			bus.$on('carUpdate', () => {
				this.getCarData()
			})
			
			
			this.evt_Arr.length = 0
			this.evt_Arr.push({
				evt: Evt_Header.Update_RecommendArr,
				hdl: payload => {
					console.log(payload)
					this.recommendArr = (payload || '').split(',')
				}
			})
			for(const evt of this.evt_Arr) {
				bus.$on(evt.evt, evt.hdl)
			}
		},
		destroyed() {
			bus.$off('carUpdate')
			for(const evt of this.evt_Arr) {
				bus.$off(evt.evt, evt.hdl)
			}
		},
		methods:{
			menuSelect(){
				this.drawer=false
			},
			goCar(){
				this.$refs.popover.doClose()
				this.$router.push("/car")
			},
			search(){
				if(!this.searchKey){
					this.$message.warning("请输入商品名称")
					return
				}
				this.$router.push({
					path:"/searchResult",
					query:{key:this.searchKey}
				})
			},
			getCarData(){
				if(this.userInfo.token){
					this.loading=true
					this.$server.post("/index.php/AppInterface/Cart/index", {
						token: this.userInfo.token,
					})
					.then(res => {
						this.loading=false
						switch (res.result) {
							case 1:
								this.$store.commit('setCarData', res.data.cart)
								this.userInfo.carNum = res.data.count
								break;
							default:
								this.$message.warning(res.msg)
								break;
						}
					})
					.catch(err => {
						this.loading=false
						console.error('getCarData: error =>', err)
						this.$message.error(this.$t('common.require-error'))
					})
				}
			},
			delCar(id){
				this.loading=true
				this.$server.post("/index.php/AppInterface/Cart/delete_cart", {
					token: this.userInfo.token,
					cart_id:id
				})
				.then(res => {
					this.loading=false
					switch (res.result) {
						case 1:
							bus.$emit('carUpdate')
							// this.getCarData()
							this.$message.success(res.msg)
							break;
						default:
							this.$message.warning(res.msg)
							break;
					}
				})
				.catch(err => {
					this.loading=false
					console.error('getCarData: error =>', err)
					this.$message.error(this.$t('common.require-error'))
				})
			},
			
			// #util
			goProduct(id) {
				if(! id) {
					console.log('goProduct: id is not found!')
					return
				}
				bus.$emit('goProduct', {
					path:"/productDetail",
					query:{
						id:id
					}
				})
			},
			userClick(type){
				if(type === 'index') {
					this.$router.push("/")
				}
				else if(type=="my") {
					this.$router.push("/my")
				}
				else if(type=="order") {
					this.$router.push("/order")
				}
				else if(type=="collect") {
					this.$router.push("/collect")
				}
				else if(type === 'address') {
					this.$router.push("/address")
				}
				else if(type === 'logout') {
					this.$store.commit('logout')
				}
			},
		}
	}
</script>

<style lang="scss">
	.header {
		// z-index: 99;
		// position: fixed;
		width: 100%;
		left: 0;
		top: 40px;
		box-sizing: border-box;
		padding: 12px 0 10px;
		background-color: #fff;
		font-size: 12px;
		
		.header_box{
			position:relative;
			max-width: $container-MaxWidth;
			min-width: $container-MinWidth;
			margin: 0 auto;
			padding: 12px 0;
			
			.header_Row {
				
				.searchBox {
					display: flex;
					justify-content: space-between;
					align-items: center;
					width: 400px;
					height: 36px;
					box-sizing: border-box;
					border: 1px solid #ccc;
					
					$ipt_H: 30px;
					input {
						width: 100%;
						height: $ipt_H;
						padding: 0 .5em 0 1em;
						outline: none;
						border: none;
						color: #555;
						line-height: $ipt_H;
					}
					.btn {
						display: flex;
						justify-content: center;
						align-items: center;
						height: 20px;
						padding-left: 1em;
						padding-right: 12px;
						border-left: 1px solid #aaa;
						color: #aaa;
						font-size: 20px;
						cursor: pointer;
						
						.btn:before {
							position: relative;
							top: 1px;
						}
					}
				}
				.logoBox {
					cursor: pointer;
					
					img {
						display: block;
						object-fit: contain;
					}
				}
				.recommendList {
					justify-content: flex-start;
					width: 100%;
					padding-left: 30px;
					color: #aaa;
					
					.item {
						margin-right: 10px;
						font-size: 12px;
						cursor: pointer;
						
						&:hover {
							color: #ef0f0f;
						}
					}
				}
			
				.cart {
					// background-color: $color-Price;
					background-color: #202020;
					color: #fff;
					cursor: pointer;
					
					.txt {
						height: 36px;
						padding: 0 2px 0 10px;
						line-height: 36px;
					}
					.icon {
						padding: 0 6px 0 0;
						font-size: 22px;
					}
					.cartItemNum {
						display: flex;
						align-items: center;
						height: 36px;
						padding: 0 8px;
						// background-color: #ef2f2f;
						background-color: #393939;
					}
				}
			}
			
			.header_item{
				display: flex;
				align-items: center;
				// .carBox
				// .foot
			}
			.header_left{
				img{
					// width: 135px;
					width: 40px;
					border-radius: 5px;
				}
				.slide{
					display: none;
				}
			}
			.header_center{
				padding: 0 15px;
				.el-input-group__append{
					background-color: $defaultColor;
					border-color: $defaultColor;
					color: #fff;
				}
			}
			.header_right{
				justify-content: flex-end;
			}
			@media (max-width: 767px){
				.header_center{
					padding: 0;
				}
				.header_right{
					// display: none;
				}
				.header_left{
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-bottom: 5px;
					.slide{
						display: flex;
						align-items: center;
						font-size: 25px;
						.el-icon-s-unfold{
							margin-left: 10px;
						}
					}
				}
			}
		}
	
		.pageHead {
			position: relative;
			height: 60px;
			margin: 0 auto;
			justify-content: center;
			line-height: 60px;
			.el-page-header__left{
				position: absolute;
				left: 0;
				padding-left: calc(15px + 7.5px);
				padding-right: calc(15px + 7.5px);
			}
		}
		@media screen and (min-width: 992px) and (max-width: 1200px) {
			.pageHead {
				.el-page-header__left {
				}
			}
		}
		@media screen and (min-width: 768px) and (max-width: 991px) {
			.pageHead {
				.el-page-header__left {
				}
			}
		}
		@media screen and (min-width: 640px) and (max-width: 767px) {
			.pageHead {
				.el-page-header__left {
					padding-left: 7.5px;
					padding-right: 7.5px;
				}
			}
		}
		@media screen and (max-width: 639px) {
			.pageHead {
				.el-page-header__left {
					padding-left: 7.5px;
					padding-right: 7.5px;
				}
			}
		}
	}
	
	.carBox{
		// height: 200px;
		.el-scrollbar__wrap{
			overflow-x: hidden;
			max-height: 200px;
			margin-bottom: 0 !important;
		}
		.el-scrollbar__thumb {
			background-color: rgba(144,147,153,.3);
		}
		.car_item{
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			padding: 10px 0;
			border-bottom: 1px dashed #c6c6c6;
			.car_item_left{
				display: flex;
				align-items: flex-start;
				.goods_img{
					width: 50px;
					height: 50px;
					margin-right: 10px;
					object-fit: cover;
					cursor: pointer;
				}
				p{
					width: 130px;
					font-size: 12px;
					line-height: 15px;
					text-overflow: -o-ellipsis-lastline;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}
			.car_item_right{
				display: flex;
				height: 50px;
				flex-direction: column;
				justify-content: space-between;
				overflow: hidden;
				font-size: 12px;
				.info {
					padding-left: 16px;
					.spec {
						display: flex;
						max-width: 80px;
						color: #000;
						font-weight: normal;
						white-space: nowrap;
						cursor: default;
						&:hover {
							white-space: normal;
						}
					}
					.price {
						font-weight: bold;
						text-align: right;
						.num {
							color: #f00;
						}
					}
				}
				.btn {
					text-align: right;
					span {
						cursor: pointer;
						&:hover {
							color: orange;
						}
					}
				}
			}
		}
		.car_item:first-child{
			padding-top: 0;
		}
		.car_item:last-child{
			border: 0;
		}
		.noData{
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			img{
				width: 100px;
				margin-bottom: 10px;
			}
			span{
				font-size: 16px;
				color: #999;
			}
		}
	}

	.foot{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Common/Header.vue